import { useTranslation } from 'libs/i18n';
import { usePageTitle } from 'libs/navigation';

import { useDocuments } from '../hooks';
import { DocumentsView } from '../views/DocumentsView';

export const DocumentsContainer = () => {
  const { t } = useTranslation();

  const { documents, loading, onClickDownload, onClickPreview } =
    useDocuments();

  usePageTitle(t('account.documents.title'));

  return (
    <DocumentsView
      documents={documents}
      loading={loading}
      onClickDownload={onClickDownload}
      onClickPreview={onClickPreview}
    />
  );
};
